import { Table } from "@/features/Table";
import { type ApiKey, api_keys_columns } from "./columns";
import { type FilterApiKeysSchema, FilterApiKeys } from "./filter";
import { useLocation } from "react-router-dom";

const client = "admin-quantilia";
const table_name = "api_keys";

export const ApiKeysTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<ApiKey, FilterApiKeysSchema>
      label="API Keys"
      client={client}
      table_name={table_name}
      columns={api_keys_columns}
      filter={<FilterApiKeys />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
